import React, { useState } from 'react';
import CenteredModal from '../../../../../../components/Modal/CenteredModal';
import { Report } from '.././../../report/hooks/types';
import CustomDropdown from '../../../../../../components/dropdown/CustomDropdown';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useMutation, useQuery } from 'react-query';
import { api } from '../../../../../../api/learningPath';
import { api as reports } from '../../../../../../api/report';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

type ReportFilterModalType = {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
};

type optionType = {
    label: string;
    value: string;
}

const ReportFilterModal: React.FC<ReportFilterModalType> = ({
    openModal,
    setOpenModal,
}) => {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [cohort, setCohort] = useState<optionType[] | null>(null)
    const [cohortsInfo, setCohortInfo] = useState<optionType[]>()
    const [reportTitle, setReportTitle] = useState<string>('')
    const navigate = useNavigate();
    const {mutateAsync, isLoading} = useMutation(reports.createReport)
    const cohortInformations: optionType[]  =  [
        { label: 'Cohort enrollment', value: 'cohort enrollment' },
        { label: 'Cohort completion status', value: 'cohort completion status' },
        { label: 'Course Completion status', value: 'course completion status' },
        { label: 'Quiz Participation Rate', value: 'quiz participation rate' },
        { label: 'Action plan', value: 'action plan' },
        { label: 'Trainee engagement', value: 'trainee engagement' },
    ]

    const orgId = JSON.parse(sessionStorage.getItem("user")!)?.org?.id;
        const {
            data: cohorts,
          } = useQuery(
            ["cohort",],
            () => {
              return api.getCohort({ id: orgId, search: '', perPage: 10000, currentPage: 1, });
            },
            {
              staleTime: 5 * 60 * 1000, // data is considered fresh for 5 minutes
              cacheTime: 30 * 60 * 1000, // data is cached for 30 minutes after becoming stale
              select: (data) => data?.data,
            }
    );

    const handleStartDateChange = (date: any) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date: any) => {
        setEndDate(date);
    };

   const onPreview = async () => {
        if(!reportTitle) {
            return toast.error('Please enter report title before applying filters')
        }
        if(!cohort?.length) {
            return toast.error('Please select cohort before applying filters')
        }
        if(!startDate || !endDate) {
            return toast.error('Please select start and end dates before applying filters')
        }
        if(!cohortsInfo?.length) {
            return toast.error('Please select cohort information before applying filters')
        }
        else{
            try {
                toast.loading("Loading...");
                const response = await reports.getReportInformation({
                   cohortIds: cohort?.map((cohort) => cohort.value)?.join(','),
                   infos: cohortsInfo?.map((info) => info.value)?.join(','),
                   startDate,
                   endDate
                });
                //toast.success(response.message);
                sessionStorage.setItem('reportInfo', JSON.stringify(response.data));
                try{
                    const payload = {
                        name: reportTitle,
                        description: '',
                        type: 'pptx',
                        size: 'full',
                        orientation: "landscape",
                        width: null,
                        height: null,
                        pixels: null,
                        status: "draft",
                    }
                    const createResponse = await mutateAsync({
                        orgId, payload,
                    }) 
                    toast.remove();
                    navigate(
                        `/admin/report/create?action=edit&reportId=${createResponse?.data?.id}&type=${'pptx'}&source=filter${
                           `&title=${reportTitle}` 
                        }`
                      );
                } catch(error){
                        toast.remove();
                        toast.error(`Error Creating Report`);
                }
                
              } catch (error) {
                toast.remove();
                toast.error(`Error Generating Data`);
              }
        }
    }

    return (
        <React.Fragment>
            <CenteredModal
                title={
                    <h5 className='text-md font-semibold bi bi-plus-circle'>
                        &nbsp; Add Report Filters
                    </h5>
                }
                open={openModal}
                setOpen={setOpenModal}
                style={{ padding: 0 }}
                width={'w-[550px] h-auto overflow-y-auto'}
                headerClassName={'flex justify-between px-3 pt-2 sticky'}
                withCloseBtn={false}
                closeButtonLabel={null}
                btnBgColor={'bg-secondary'}
                onClose={(): void => {}}
            >
                <section className='text-left px-3 pt-3'>
                    <div>
                     <label className='text-sm'>Report Title</label>
                     <input
                        name="name"
                        className="input-style bg-primaryGray"
                        placeholder="Enter Report Title"
                        value={reportTitle}
                        onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                            setReportTitle(event.target.value as string)
                        } }
                    />
                    </div>
                    <div className='pt-2'>
                        <label className='text-sm'>Cohort</label>
                        <CustomDropdown
                            options={ cohorts?.length ?
                                 cohorts?.map((cohort: any) => {
                                     return {
                                         label: cohort?.cohort?.name,
                                         value: cohort?.cohort?.id
                                     }
                                 })
                                : []
                                }
                            value={cohort}
                            onChange={(value: any) => {
                                setCohort(value)
                            }}
                            onBlur={(value: any) => {}}
                            name={'cohort'}
                            className={'bg-primaryGray select-custom'}
                            width={'w-full'}
                            placeholder={'Select Cohort'}
                            multiSelect
                        />
                    </div>
                    <div className='mt-4'>
                        <label className='text-sm'>Cohort Information</label>
                        <CustomDropdown
                            multiSelect
                            options={cohortInformations}
                            value={cohortsInfo}
                            onChange={(value: any) => {
                                setCohortInfo(value)
                            }}
                            onBlur={(value: any) => {}}
                            name={'cohort info'}
                            className={'bg-primaryGray select-custom'}
                            width={'w-full'}
                            placeholder={'Cohort Information'}
                        />
                    </div>
                    <div className='mt-4'>
                          <div className='flex justify-between'>
                           <div>
                            <label className='text-sm'>
                                Start Date
                            </label>
                             <ReactDatePicker
                                    onChange={handleStartDateChange}
                                    selected={startDate}
                                    dateFormat='dd/MM/yyyy'
                                    className='input-style w-full bg-primaryGray mr-2'
                                    placeholderText='Start Date'
                                />
                           </div>
                            <div>
                            <label className='text-sm pl-2'>
                                End Date
                            </label>
                                <ReactDatePicker
                                    onChange={handleEndDateChange}
                                    selected={endDate}
                                    min={startDate}
                                    dateFormat='dd/MM/yyyy'
                                    className='input-style w-full bg-primaryGray ml-2'
                                    placeholderText='End Date'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-end items-center mt-4'>
                      <button 
                        className='btn bg-primary-blue px-8'
                        onClick={onPreview}     
                      >
                          Preview
                       </button>
                       {/* <button className='btn bg-primary-blue px-8'>
                          Generate
                       </button> */}
                    </div>
                </section>
            </CenteredModal>
        </React.Fragment>
    );
};

export default ReportFilterModal;